<template>
    <div>
        <header class="main-header" :class="{visible : headerVisible}">
            <nav class="km-navbar navbar-static-top" v-on:click="config()">
                <div class="navbar-custom-menu km-navbar-left">
                    <ul class="km-nav km-navbar-nav">
                        <li class="dropdown user user-menu">
                            <a class="currentTime">{{currentTime | formatTime}}</a>
                        </li>
                        <li class="dropdown user user-menu">
                            <a class='wifi icon'>
                                <i class="icon icon-wifi" :class="{connected : timelineSettings.connected}"></i>
                            </a>
                        </li>
                        <li class="dropdown user user-menu">
                            <a class='link icon'>
                                <span class="config"><i class="icon icon-cog"></i></span>
                            </a>
                        </li>

                        <li class="dropdown user user-menu">
                            <a class="currentTime"><translate item="Serve.Configuration" /></a>
                        </li>

                    </ul>
                </div>
            </nav>

        </header>
        <div class="text-center">
            <h1><translate item="Serve.Title" /></h1>
        </div>
        <div class="row">
            <div class="serve pending col-6">
                <div class="head">
                    <i class="icon icon-bereiding-klant"> </i>
                    <span class="caption"><translate item="Serve.Pending" /></span>
                </div>
                <div class="orders">
                    <div class="order" v-for="order in pendingReciepts" :key="order.id">{{order.customerOrderNr || order.orderNr}}</div>
                    <div class="panel" v-if="!pendingReciepts.length">

                    </div>
                </div>

            </div>
            <div class="serve done col-6">
                <div class="head">
                    <i class="icon icon-gereed-klant"> </i>
                    <span class="caption"><translate item="Serve.Ready" /></span>
                </div>
                <div class="orders">
                    <div class="order" v-for="order in doneReciepts" :key="order.id">{{order.customerOrderNr || order.orderNr}}</div>
                    <div class="panel" v-if="!doneReciepts.length">
                    </div>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="text-center"><translate item="Serve.Enjoy" /></div>
            <!--<div class="serve pending col-6">
                <span class="order-oveflow" v-for="order in pendingOverflowReciepts" :key="order.id">{{order.customerOrderNr || order.orderNr}}</span>
            </div>
            <div class="serve done col-6">
                <span class="order-oveflow" v-for="order in doneOverflowReciepts" :key="order.id">{{order.customerOrderNr || order.orderNr}}</span>
            </div>-->
            <div class="logo"></div>
        </div>
    </div>
</template>

<script>

    import translate from '../components/translate'
    import timeStore from '../repositories/TimeManager';
    import configRepository from '../repositories/ConfigRepository';

    import { OrderStatus, BatchStatus } from '../repositories/Constants';

    const Serve = {

        components: { translate },

        data: function () {
            return {
                Orders: this.$signalR.orders,
                timelineSettings: this.$signalR.timelineSettings,
                serveUnitGroupIds: [],
                pendingStates: [BatchStatus.Planned, BatchStatus.Preparing, BatchStatus.Preparing],
                doneStates: [BatchStatus.Prepared, BatchStatus.Parceling, BatchStatus.Parceled],
                currentTime: timeStore.state.now,
                headerVisible: false,
                pendingOrderTake: 100,
                doneOrderTake: 100
            }
        },

        methods: {

            determineFutureOrders: function () {

                var futureOrders = false;

                // determine future orders
                this.Orders.forEach(function (order) {
                    futureOrders = timeStore.setOrderToFuture(order) || futureOrders;
                });


            },

            config: function () {
                window.location = '/#config';
            },


        },

        computed: {

            _pendingReciepts: function () {
                var _this = this;
                return this.sortedOrders.filter(a => {
                    return _this.pendingStates.some(b => b == a.status)
                });
            },

            pendingReciepts: function () {
                return this._pendingReciepts.slice(0, this.pendingOrderTake);
            },

            pendingOverflowReciepts: function () {
                return this._pendingReciepts.slice(this.pendingOrderTake);
            },

            _doneReciepts: function () {
                var _this = this;
                return this.sortedOrders.filter(a => {
                    return _this.doneStates.some(b => b == a.status)
                });
            },

            doneReciepts: function () {
                return this._doneReciepts.slice(0, this.doneOrderTake);
            },

            doneOverflowReciepts: function () {
                return this._doneReciepts.slice(this.doneOrderTake);
            },

            sortedOrders: function () {

                var orders;

                if (this.serveUnitGroupIds && this.serveUnitGroupIds.length) {
                    orders = this.Orders.filter(a => {
                        return !a.futurePending && a.batches && a.batches.some(b => {
                            return this.serveUnitGroupIds.indexOf(b.unitGroupId) >= 0;
                        });
                    });
                } else {
                    orders = this.Orders.filter(a => !a.futurePending);
                }

                return orders.sort(function (a, b) {
                    if (a.sortableStartDateString < b.sortableStartDateString) {
                        return -1;
                    } else {
                        return 0;
                    }
                });

            },

            /**
             * Returns all the reciepts which are in the future
             * */
            futureRecieptsOfUnits: function () {

                var _this = this;

                // this.Orders.filter(a => { return a.status < 2 } )
                return this.visibleOrders.filter(a => {
                    return a.futurePending && a.status < 4 && a.batches && a.batches.some(b => {
                        return _this.visibleUnits.some(c => { return c.id == b.unitGroupId });
                    });
                });

            },


        },

        watch: {


            "Orders": function () {
                this.determineFutureOrders();
            }

        },

        mounted: function () {

            // the unit groups to show the collect orders from.
            this.serveUnitGroupIds = configRepository.getConfig().serveUnitGroupIds;

            var _this = this;

            // watch, computed is for some reason not responsive, todo, find out why
            window.setInterval(function () {
                timeStore.setNow(new Date());
                _this.currentTime = timeStore.state.now;
            }, 2000)

            window.setInterval(function () { _this.determineFutureOrders() }, 20000);

            document.addEventListener('mousemove', e => {
                mouseAction(e);
            });
            document.addEventListener('mousedown', e => {
                mouseAction(e);
            });

            function mouseAction(e) {
                if (e.clientY < 150) {
                    _this.headerVisible = true;
                } else {
                    _this.headerVisible = false;
                }
            }

        }

    };

    export { Serve as default };
</script>